// extracted by mini-css-extract-plugin
module.exports = {"container":"list_container_1QWZ8","list":"list_list_WGx0k","item":"list_item_2UZXU","ficon":"list_ficon_3iUOt"};